import * as React from "react"
import { cn } from "../lib/utils.ts"

/* shadcn/ui Textarea, restyled like Input (the control-field well, edge and focus ring). Body text (14/20) because it holds prose. */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "control-field flex field-sizing-content min-h-16 w-full px-3 py-2 text-body pointer-coarse:text-(length:--touch-input-font)",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
